export default "__VITE_ASSET__342fd528__"